export default "__VITE_ASSET__C0sfi13w__"